import React, { useCallback, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import CustomHeader from '../../../../common/header/Header';

import { updateQuotasQueryParams } from '../store/adminQuotasSettings.actions';
import { selectQuotasQueryParams } from '../store/adminQuotasSettings.selectors';
import { getCorrectSearchValue } from '../../../../../utils/helpers/getCorrectSearchValue';

const QuotaPageHeader = () => {
    const dispatch = useDispatch();

    const queryParams = useSelector(selectQuotasQueryParams);
    const searchQuery = queryParams.search;
    const [searchValue, setSearchValue] = useState(searchQuery);

    const updateQuotasParams = useCallback(() => {
        const trimmedSearchValue =
            typeof searchValue === 'string' ? getCorrectSearchValue(searchValue) : null;
        if (trimmedSearchValue !== null) {
            const timeoutId = setTimeout(() => {
                dispatch(
                    updateQuotasQueryParams({
                        search: trimmedSearchValue,
                        page: 1,
                    })
                );
            }, 1500);

            return () => clearTimeout(timeoutId);
        }
    }, [dispatch, searchValue]);

    useEffect(() => {
        return updateQuotasParams();
    }, [searchQuery, updateQuotasParams]);

    const handleSearch = useCallback((value) => {
        setSearchValue(value);
    }, []);

    return (
        <CustomHeader
            showSearch
            handleSearch={handleSearch}
            defaultSearchValue={searchQuery}
            searchValue={searchValue}
        />
    );
};

export default QuotaPageHeader;
